import React from 'react'
import PropTypes from 'prop-types'

import pretty from '@st-operations/uikit/lib/pretty.js'

import './styles.scss'

// The segment (mapping) IDs a taxonomy segment carries, one line per destination
// its taxonomy distributes to - the same pairing "Download Mapping IDs" exports
// for a whole taxonomy, read here for a single segment.
//
// The rows arrive ready-made from the API (`segment_ids` on the audience):
// pairing a destination with an id means reading the taxonomy's distributions,
// and the mapping-space keys the id hides behind are mangled by the camelizing
// this app applies to every response.
//
// A destination with no id yet keeps its line, showing a dash - that gap is the
// "Need New Segment IDs" state seen from one segment, and it is worth seeing.
const SegmentIds = ({ segmentIds }) => {
  if (!segmentIds.length) return null

  return (
    <div className="ac-segment-ids">
      <div className="ac-segment-ids__title">Segment IDs</div>
      <div className="ac-segment-ids__list">
        <For each="row" index="index" of={segmentIds}>
          <div className="ac-segment-ids__item" key={`${row.destination}-${row.mappingIds}`}>
            <span className="ac-segment-ids__destination">{pretty(row.destination)}:</span>
            <span className="ac-segment-ids__id">{row.segmentId || '—'}</span>
          </div>
        </For>
      </div>
    </div>
  )
}

SegmentIds.propTypes = {
  segmentIds: PropTypes.arrayOf(
    PropTypes.shape({
      destination: PropTypes.string,
      mappingIds: PropTypes.string,
      segmentId: PropTypes.string,
    })
  ),
}

SegmentIds.defaultProps = {
  segmentIds: [],
}

export default SegmentIds
